import { isObject } from './object';

// 一天的总时间（ms）
const TIME_OF_DAY = 24 * 60 * 60 * 1000;

// 默认 cookie 存储时间 30 天
const DEFAULT_EXPIRES_TIME = 30 * TIME_OF_DAY;

function stringify(value: any) {
  return isObject(value) ? JSON.stringify(value) : value;
}

/**
 * 新增一个 cookie 值
 * @param key cookie key
 * @param value cookie value
 * @param expiresInDay 过期时间，以天为单位，默认为30天
 * @param path 如果没有定义，默认为当前文档位置的路径
 * @param domain 如果没有定义，默认为当前文档位置的路径的域名部分
 */
export function setCookie(key: string, value: any, expiresInDay?: number, path?: string, domain?: string): void {
  const encodeValue = encodeURIComponent(stringify(value));
  let expireTime = expiresInDay ? expiresInDay * TIME_OF_DAY : DEFAULT_EXPIRES_TIME;
  const expireDate = new Date();
  expireTime += expireDate.getTime();
  expireDate.setTime(expireTime);
  // 过期时间
  const expires = expireDate.toUTCString();
  const finalPath = path || '/';
  const finalDomain = domain ? (`domain=${domain};`) : '';
  // 写 cookie
  document.cookie = `${key}=${encodeValue};expires=${expires};path=${finalPath};${finalDomain}`;
}

/**
 * 删除一个 cookie
 * @param key 待删除的 cookie key 值
 * @param path cookie 路径
 * @param domain cookie 域名
 */
export function delCookie(key: string, path?: string, domain?: string): void {
  const finalPath = path ? path : '/';
  const finalDomain = domain ? (`domain=${domain};`) : '';

  // 重置过期时间expire
  const expires = new Date(0).toUTCString();
  document.cookie = `${key}=;expires=${expires};path=${finalPath};${finalDomain}`;
}

/**
 * 获取一个 cookie
 * @param key 待获取的 cookie 的 key
 */
export function getCookie(key: string): string | null {
  const reg = new RegExp(`(?:^|;+|\\s+)${key}=([^;]*)`);

  const result = document.cookie.match(reg);
  return (!result ? null : result[1]) || null;
}

/**
 * 清除所有的 cookie
 */
export function clearAllCookie(): void {
  const cookies = document.cookie.split(';');
  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
}

/**
 * 返回所有的 cookie
 * @returns 所有 cookie 的数组形式
 */
export function getAllCookie(): string[] {
  return document.cookie.split(';').map(val => val?.trim());
}
